(function () {
  if (window.__collectionTabFiltersInit) {
    return;
  }
  window.__collectionTabFiltersInit = true;

  function debounce(fn, delay) {
    var timer;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(null, args);
      }, delay);
    };
  }

  function getPanel(el) {
    return el ? el.closest('[data-tab-panel]') : null;
  }

  function getSectionScope(el) {
    if (!el) {
      return document;
    }

    return el.closest('.container-inner') || el.closest('[id^="shopify-section-"]') || document;
  }

  function syncTabState(scope, target, title) {
    if (!scope || !target) {
      return;
    }

    scope.querySelectorAll('.list-product-tabs .nav-link[data-target]').forEach(function (link) {
      link.classList.toggle('active', link.dataset.target === target);
    });

    scope.querySelectorAll('.collection-tabs-content > .tab-content').forEach(function (tabContent) {
      tabContent.classList.toggle('active', '#' + tabContent.id === target);
    });

    if (title) {
      scope.querySelectorAll('.nav-mobile__title').forEach(function (label) {
        label.textContent = title;
      });
    }
  }

  function renderSidebarTabs(panel) {
    if (!panel) {
      return;
    }

    var scope = getSectionScope(panel);
    var template = scope.querySelector('template[data-tab-sidebar-nav-template]');

    if (!template) {
      return;
    }

    panel.querySelectorAll('[data-tab-sidebar-nav]').forEach(function (node) {
      node.innerHTML = template.innerHTML;
    });
  }

  function getOverlay() {
    return document.querySelector('.sidebar-overlay');
  }

  function closeSidebar(toggleKey, scope) {
    var root = scope || document;
    var overlay = getOverlay();

    root.querySelectorAll('.nov_btn_act[data-toggle="' + toggleKey + '"]').forEach(function (button) {
      button.classList.remove('act');
    });
    root.querySelectorAll('.nov_item_act[data-act="' + toggleKey + '"]').forEach(function (item) {
      item.classList.remove('act');
    });

    document.body.classList.remove(toggleKey + '-open');

    if (overlay && overlay.getAttribute('data-close') === toggleKey) {
      overlay.classList.remove('act');
      overlay.removeAttribute('data-close');
    }
  }

  function openSidebar(button) {
    var toggleKey = button.dataset.toggle;
    var scope = button.closest('.template-collection') || getPanel(button) || document;
    var overlay = getOverlay();
    var wasActive = button.classList.contains('act');

    scope.querySelectorAll('.nov_btn_act').forEach(function (item) {
      item.classList.remove('act');
    });
    scope.querySelectorAll('.nov_item_act').forEach(function (item) {
      item.classList.remove('act');
    });

    if (wasActive) {
      closeSidebar(toggleKey, scope);
      return;
    }

    button.classList.add('act');
    scope.querySelectorAll('.nov_item_act[data-act="' + toggleKey + '"]').forEach(function (item) {
      item.classList.add('act');
    });
    document.body.classList.add(toggleKey + '-open');

    if (overlay) {
      overlay.classList.add('act');
      overlay.setAttribute('data-close', toggleKey);
    }
  }

  function closePanelSidebar(panel) {
    if (!panel) {
      return;
    }

    var scope = panel.querySelector('.template-collection') || panel;
    var activeButton = scope.querySelector('.nov_btn_act.act[data-toggle]');

    if (activeButton) {
      closeSidebar(activeButton.dataset.toggle, scope);
    }
  }

  function buildViewUrl(baseUrl, params, nextPage, panel) {
    if (!baseUrl) {
      return '';
    }

    var url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('view', 'tab-filters');
    if (panel && panel.dataset && panel.dataset.limit) {
      url.searchParams.set('limit', panel.dataset.limit);
    }

    if (params) {
      params.forEach(function (value, key) {
        if (value !== '') {
          url.searchParams.append(key, value);
        }
      });
    }

    if (nextPage) {
      url.searchParams.set('page', nextPage);
    } else {
      url.searchParams.delete('page');
    }

    return url.toString();
  }

  function getFormParams(panel) {
    var form = panel.querySelector('[data-tab-filters-form]');
    return form ? new URLSearchParams(new FormData(form)) : new URLSearchParams();
  }

  function applyPanelClasses(panel) {
    var grid = panel.querySelector('[data-tab-products]');
    var colClasses = panel.dataset.colClasses || '';
    var gridClasses = panel.dataset.gridClasses || '';
    var loadmoreClasses = panel.dataset.loadmoreClasses || '';

    if (grid) {
      grid.className = gridClasses;
      grid.querySelectorAll(':scope > .item').forEach(function (item) {
        item.className = ('item ' + colClasses).trim();
      });
    }

    var loadmoreButton = panel.querySelector('[data-tab-loadmore]');
    if (loadmoreButton && loadmoreClasses) {
      loadmoreButton.className = loadmoreClasses;
    }
  }

  function refreshProductCards(panel) {
    applyPanelClasses(panel);

    if (window.nuranium && typeof window.nuranium.initNovWishListIcons === 'function') {
      window.nuranium.initNovWishListIcons();
    }

    if (window.avadaAirReviewRerender && document.querySelector('.AirReviews-Widget')) {
      window.avadaAirReviewRerender();
    }
  }

  function renderPanel(panel, url) {
    if (!url) {
      return Promise.resolve();
    }

    closePanelSidebar(panel);
    panel.classList.add('is-loading');

    return fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextContent = doc.querySelector('.collection-tab-panel__content');

        if (!nextContent) {
          nextContent = doc.body;
        }

        if (!nextContent) {
          return;
        }

        panel.querySelector('.collection-tab-panel__content').innerHTML = nextContent.innerHTML;
        renderSidebarTabs(panel);
        var currentTab = panel.closest('.tab-content');
        if (currentTab) {
          syncTabState(getSectionScope(panel), '#' + currentTab.id);
        }
        panel.dataset.loaded = 'true';
        refreshProductCards(panel);
      })
      .finally(function () {
        panel.classList.remove('is-loading');
      });
  }

  function ensurePanelLoaded(panel) {
    if (!panel || panel.dataset.loaded === 'true') {
      return;
    }

    renderPanel(panel, buildViewUrl(panel.dataset.collectionUrl, new URLSearchParams(), null, panel));
  }

  function updateLoadmoreState(panel, totalItems) {
    var count = panel.querySelector('[data-tab-panel-count] .count');
    var progress = panel.querySelector('[data-tab-panel-progress]');
    var bar = panel.querySelector('[data-tab-panel-bar]');
    var max = bar ? parseInt(bar.dataset.max, 10) : 0;

    if (count) {
      count.textContent = totalItems;
    }

    if (progress && max) {
      progress.style.width = totalItems / max * 100 + '%';
    }
  }

  function loadMore(panel, button) {
    var nextPage = parseInt(button.dataset.nextPage, 10);

    if (!nextPage) {
      return;
    }

    button.classList.add('loading');

    var nextUrl = buildViewUrl(panel.dataset.collectionUrl, getFormParams(panel), nextPage, panel);

    if (!nextUrl) {
      return;
    }

    fetch(nextUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextProducts = doc.querySelector('[data-tab-products]');
        var nextWrap = doc.querySelector('[data-tab-loadmore-wrap]');
        var currentProducts = panel.querySelector('[data-tab-products]');
        var currentWrap = panel.querySelector('[data-tab-loadmore-wrap]');

        if (!nextProducts || !currentProducts || !currentWrap) {
          return;
        }

        currentProducts.insertAdjacentHTML('beforeend', nextProducts.innerHTML);
        currentWrap.innerHTML = nextWrap ? nextWrap.innerHTML : '';
        refreshProductCards(panel);
        updateLoadmoreState(panel, currentProducts.querySelectorAll(':scope > .item').length);
      })
      .finally(function () {
        button.classList.remove('loading');
      });
  }

  var debouncedFilterChange = debounce(function (form) {
    var panel = getPanel(form);
    if (!panel) {
      return;
    }
    renderPanel(panel, buildViewUrl(panel.dataset.collectionUrl, new URLSearchParams(new FormData(form)), null, panel));
  }, 350);

  document.addEventListener('input', function (event) {
    var form = event.target.closest('[data-tab-filters-form]');
    if (!form) {
      return;
    }
    debouncedFilterChange(form);
  });

  document.addEventListener('click', function (event) {
    var tabLink = event.target.closest('.list-product-tabs .nav-link[data-target]');
    if (tabLink) {
      event.preventDefault();
      var target = tabLink.dataset.target;
      var scope = getSectionScope(tabLink);

      if (!target) {
        return;
      }

      syncTabState(scope, target, tabLink.textContent.trim());
      scope.querySelectorAll('[data-tab-panel]').forEach(closePanelSidebar);

      var panelWrap = scope.querySelector(target + ' [data-tab-panel]');
      ensurePanelLoaded(panelWrap);
      return;
    }

    var toggleButton = event.target.closest('.collection-tab-panel .nov_btn_act[data-toggle]');
    if (toggleButton) {
      event.preventDefault();
      openSidebar(toggleButton);
      return;
    }

    var closeButton = event.target.closest('.collection-tab-panel .nov_btn_close[data-close]');
    if (closeButton) {
      event.preventDefault();
      closeSidebar(closeButton.dataset.close, closeButton.closest('.template-collection') || getPanel(closeButton) || document);
      return;
    }

    var link = event.target.closest('[data-tab-filter-link]');
    if (link) {
      event.preventDefault();
      var panel = getPanel(link);
      if (!panel) {
        return;
      }
      renderPanel(panel, buildViewUrl(link.href, null, null, panel));
      return;
    }

    var button = event.target.closest('[data-tab-loadmore]');
    if (button) {
      event.preventDefault();
      var panel = getPanel(button);
      if (!panel) {
        return;
      }
      loadMore(panel, button);
    }
  });

  function initPriceRange(rangeRoot) {
    if (!rangeRoot || rangeRoot.dataset.bound === 'true') {
      return;
    }

    var rangeInputs = rangeRoot.querySelectorAll('.filter__price--range input');
    var priceInputs = rangeRoot.querySelectorAll('.filter__price--input input');
    var rangeBar = rangeRoot.querySelector('.filter__price--bar .progress');
    var priceGap = 5;

    if (rangeInputs.length < 2 || priceInputs.length < 2 || !rangeBar) {
      return;
    }

    function syncRangeFromInputs() {
      var minPrice = parseInt(priceInputs[0].value || 0, 10);
      var maxPrice = parseInt(priceInputs[1].value || rangeInputs[1].max, 10);

      if (Number.isNaN(minPrice)) {
        minPrice = 0;
      }
      if (Number.isNaN(maxPrice)) {
        maxPrice = parseInt(rangeInputs[1].max, 10);
      }

      if (maxPrice - minPrice < priceGap) {
        maxPrice = minPrice + priceGap;
      }

      rangeInputs[0].value = minPrice;
      rangeInputs[1].value = maxPrice;
      rangeBar.style.left = minPrice / rangeInputs[0].max * 100 + '%';
      rangeBar.style.right = 100 - maxPrice / rangeInputs[1].max * 100 + '%';
    }

    function syncInputsFromRange(targetClass) {
      var minVal = parseInt(rangeInputs[0].value, 10);
      var maxVal = parseInt(rangeInputs[1].value, 10);

      if (maxVal - minVal < priceGap) {
        if (targetClass === 'field__range--min') {
          rangeInputs[0].value = maxVal - priceGap;
        } else {
          rangeInputs[1].value = minVal + priceGap;
        }
        minVal = parseInt(rangeInputs[0].value, 10);
        maxVal = parseInt(rangeInputs[1].value, 10);
      }

      priceInputs[0].value = minVal;
      priceInputs[1].value = maxVal;
      rangeBar.style.left = minVal / rangeInputs[0].max * 100 + '%';
      rangeBar.style.right = 100 - maxVal / rangeInputs[1].max * 100 + '%';
    }

    priceInputs.forEach(function (input) {
      input.addEventListener('input', syncRangeFromInputs);
    });

    rangeInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        syncInputsFromRange(input.className);
      });
    });

    syncRangeFromInputs();
    rangeRoot.dataset.bound = 'true';
  }

  function initAllPriceRanges(scope) {
    (scope || document).querySelectorAll('[data-tab-price-range]').forEach(initPriceRange);
  }

  initAllPriceRanges(document);
  document.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
    renderSidebarTabs(panel);
    refreshProductCards(panel);
  });
  document.querySelectorAll('.collection-tabs-content > .tab-content.active [data-tab-panel]').forEach(ensurePanelLoaded);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) {
          return;
        }

        if (node.matches && node.matches('[data-tab-price-range]')) {
          initPriceRange(node);
        }

        if (node.querySelectorAll) {
          initAllPriceRanges(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
